// @flow

import { withRouter } from "react-router";
import React, { Component } from "react";
import { compose } from "react-apollo";

import type { UserProfile } from "../../data/accounts";
import { withUpdateUser, withUser } from "../../data/accounts";

import UserProfileForm from "../../components/UserProfileForm/UserProfileForm";

import WithLoadingIndicator from "../../components/WithLoadingIndicator/WithLoadingIndicator";
import Page from "../../components/Page/Page";
import WithTracker from "../../components/WithTracker/WithTracker";

import "./UserInfo.css";

// FIXME
type Props = Object;
type State = {};

class UserInfo extends Component<Props, State> {
  updateUserProfile = (profile: UserProfile) => {
    const updateUserParams = {
      variables: { id: this.props.userData.user.id, ...profile }
    };
    const onError = e => {
      console.error(e);
      alert(
        "Couldn't save your user profile information at this time, please try again later"
      ); // TODO - redirect to error page
      throw e;
    };
    this.props
      .updateUser(updateUserParams)
      .then(response => {
        console.log("updateUser: response: ", response);
        this.props.history.push("/");
      })
      .catch(onError);
  };

  render() {
    return (
      <Page className="UserInfo" title="User Profile">
        <UserProfileForm
          onSubmit={this.updateUserProfile}
          submitButtonLabel="Save and Continue"
          subtitleText="Please accurately fill out this 1-page survey."
        />
      </Page>
    );
  }
}

const extendComponent = compose(
  WithTracker,
  withUser,
  withUpdateUser,
  withRouter,
  WithLoadingIndicator
);

export default extendComponent(UserInfo);



// WEBPACK FOOTER //
// ./src/pages/UserInfo/UserInfo.js